import { render, staticRenderFns } from "./category-additionals-extras.vue?vue&type=template&id=d07012ca&scoped=true"
import script from "./category-additionals-extras.vue?vue&type=script&lang=js"
export * from "./category-additionals-extras.vue?vue&type=script&lang=js"
import style0 from "./category-additionals-extras.vue?vue&type=style&index=0&id=d07012ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d07012ca",
  null
  
)

export default component.exports